export default __webpack_public_path__ + "static/media/Group 5.6f0dd115.png";